import { Component, Match, Switch } from 'solid-js';

import { CreateGetStreamedTime } from '~/utils/types';
import { LiveMetadataUpdater } from './LiveMetadataUpdater';
import { VodMetadataUpdater } from './VodMetadataUpdater';

interface MetadataUpdaterProps {
  contentId: {
    id: string;
    isLive: boolean;
  };
  asset: {
    mainAssetId: string;
    vmsId: string;
    type: string;
  };
  streamedContentTime: CreateGetStreamedTime;
  onFinished: () => void;
  onProgramCompletion: () => void;
}

export const MetadataUpdater: Component<MetadataUpdaterProps> = (props) => (
  <Switch>
    <Match when={props.contentId.isLive}>
      <LiveMetadataUpdater
        channelId={props.contentId.id}
        streamedContentTime={props.streamedContentTime}
        onFinished={props.onFinished}
        onProgramCompletion={props.onProgramCompletion}
      />
    </Match>
    <Match when={!props.contentId.isLive}>
      <VodMetadataUpdater
        vrioAssetId={props.contentId.id}
        asset={props.asset}
        streamedContentTime={props.streamedContentTime}
        onFinished={props.onFinished}
      />
    </Match>
  </Switch>
);
